import CacheCleaner from "./CacheCleaner"
import CacheManager from "../CacheManager"

export default class ContractCleaner extends CacheCleaner {

	async onMutation(contract_ids, columns) {
		await CacheManager.inst().onObjectsMutation('contract', contract_ids, columns)
	}
}
